import course1 from "../../assets/images/course-1.jpg";
import software from "../../assets/images/software.jpg";
import energySystem from "../../assets/images/energy_system.jpg";
import environmental from "../../assets/images/enviroment_system.png";
import oilGas from "../../assets/images/oil_gas.jpg";
import safetyRisk from "../../assets/images/saftey_risk.jpg";
import internationalBuis from "../../assets/images/international_buis.jpg";
import artDesign from "../../assets/images/art&design.jpg";
import changeManagement from "../../assets/images/changeManagement.jpg";
import dataAnalytics from "../../assets/images/dataAnalytics.jpg";
import financialAnalytics from "../../assets/images/financialAnalytics.jpg";
import management from "../../assets/images/management.jpg";
import technologyManagement from "../../assets/images/technologyManagement.jpg";
import businessHealth from "../../assets/images/businessHealth.jpg";
import it from "../../assets/images/it.jpg";
import it2 from "../../assets/images/it2.jpg";
import artDesignEng from "../../assets/images/artDesignEng.jpg";
import artDesign2 from '../../assets/images/artDesign2.jpg';
import health1 from '../../assets/images/health1.jpg';
import health3 from '../../assets/images/health3.jpg';
import eng2 from '../../assets/images/eng2.jpg';

import masterOfArtificalIng from '../../assets/images/1-Master-of-Artificial-IntelligenceDesign&Development.jpg'
import masterOfAppliedEconomics from '../../assets/images/2-Master-ofApplied-Economics-andPolicy.jpg'
import masterofActuarialScience from '../../assets/images/3-MasterofActuarialScience.jpg'
import masterofBusinessdministration from '../../assets/images/4-MasterofBusinessdministration.jpg'
import appliedComputing from '../../assets/images/5-AppliedComputing.jpg'
import masterofEducation from '../../assets/images/6-MasterofEducation.jpg'
import masterofEngineering from '../../assets/images/7-MasterofEngineering.jpg'
import MasterofEngineering from '../../assets/images/8-MasterofEngineering–ElectricVehicle.jpg'
import MasterofManagement from '../../assets/images/9-MasterofManagement.jpg'
import MasterofMedicalBiotechnology from '../../assets/images/10-MasterofMedicalBiotechnology.jpg'
import MasterofSportsManagement from '../../assets/images/11-MasterofSportsManagement.jpg'
import MasterofEngineeringManagement from '../../assets/images/12-MasterofEngineeringManagement.jpg'
import MasterofBusinessAdministration from '../../assets/images/13-MasterofBusinessAdministration.jpg'
import MasterofQuantitativeInvestmentManagement from '../../assets/images/14-MasterofQuantitativeInvestmentManagement.jpg'
import TechnologyManagementandEntrepreneurship from '../../assets/images/15-TechnologyManagementandEntrepreneurship.jpg'
import MasterofEngineeringLeadershipinDesignInnovation from '../../assets/images/16-MasterofEngineeringLeadershipinDesignInnovation.jpg'
import MasterofEngineering2 from '../../assets/images/17-MasterofEngineering.jpg'
import MasterofEnvironmentalManagement from '../../assets/images/18-MasterofEnvironmentalManagement.jpg'
import MasterofComputerScience from '../../assets/images/19-MasterofComputerScience.jpg'
import MasterofAppliedCybersecurity from '../../assets/images/20-MasterofAppliedCybersecurity.jpg'
import MasterofEducation from '../../assets/images/21-MasterofEducation.jpg'
import MasterofBusinessAdministration2 from '../../assets/images/22-Pre-MasterofBusinessAdministration.jpg'
import MasterofAppliedPsychologyResearchandEvaluation from '../../assets/images/23-MasterofAppliedPsychologyResearchandEvaluation.jpg'
import MasterofAppliedComputerScience from '../../assets/images/MasterofAppliedComputerScience.jpg.jpg'
import MasterofDigitalInnovation  from '../../assets/images/MasterofDigitalInnovation.jpg.jpg'
import MasterofEngineeringBiological  from '../../assets/images/MasterofEngineeringBiological.jpg.jpg'
import MasterofEngineeringChemical  from '../../assets/images/MasterofEngineeringChemical.jpg.jpg'
import MasterofPublicAdministration  from '../../assets/images/MasterofPublicAdministration.jpg.jpg'
// import MasterofMedicalBiotechnology from '../../assets/images'

export const dataList = [
  {
    id: "1",
    targetId: "desi",
    category: "Engineering",
    imgUrl: course1,
    courseTitle: "MASc - Computer Engineering",
    courseDesc:
      "Prepares for Careers In Telecom, IT, Software, and Hardware Design, Providing Balanced Expertise In Computer Hardware, Software, and Key Applications.",
    courseLink: "/course-details",
    tabOneOverView: `The Master of Applied Science in Software Engineering (MASc.SE) is a course-based master’s program intended for students with a computer science or computer engineering background who wish to upgrade their background to specialize in software engineering. The MASc.SE is a four-term, course-based master’s program offered jointly by the Faculty of Engineering and Applied Science and the Faculty of Science. Graduates of the program will have knowledge and understanding of the core areas and methods in software engineering and will be ready to work in positions of software development, computer systems architecture and design, and distributed services. The program distinguishes itself from existing course options in computer science and computer engineering with its increased focus on software engineering and related topics and a decreased emphasis on other areas, such as hardware, digital design and communications.\n\n**Course Requirements:**\nThe program consists of 21 credit hours of core courses and nine credit hours of elective courses (subject to the chair of the program’s approval), either from the list below or an approved replacement.\n\n**Seven Core Courses (3 credit hours each):**\n- ENGI 9818 Software Fundamentals\n- ENGI 9867 Advanced Computing Concepts for Engineering\n- ENGI 9874 Software Design and Specification\n- ENGI 9839 Software Verification and Validation\n- ENGI 9837† Software Engineering Capstone (normally taken in final term)\n- COMP 6901 Applied Algorithms\n- COMP 6905 Software Engineering\n\n**Electives (choose three, or get approval for alternatives):**\n- ENGI 9823 Computer Security or COMP 6916 Security and Privacy\n- ENGI 9838 Software Engineering Practice\n- ENGI 9861 High-performance Computer Architecture or COMP 6904 Advanced Computer Architecture\n- ENGI 9869 Advanced Concurrent Programming or COMP 6903 Concurrent Computing\n- ENGI 9872 Digital Communications\n- ENGI 9875 Embedded and Real-time Systems Design or COMP 6925 Advanced Operating Systems\n- ENGI 9876 Advanced Data Networks\n- ENGI 9877 Cryptography\n- COMP 6908 Database Technology and Applications\n- COMP 6910 Services Computing, Semantic Web and Cloud Computing\n- COMP 6921 Syntax and Semantics of Programming Languages\n- COMP 6922 Compiling Methods\n- COMP 6934 Introduction to Data Visualization\n- AI 6001 Topics in Artificial Intelligence\n\nStudents who take more than the required number of core or elective courses will be charged tuition as per university policy for each additional course completed.`,
    tabTwoFastTrack: "Students registered in academic term 7 of an undergraduate engineering degree at Memorial University are eligible to apply for admission to the M.Eng. fast track option. This option has been put in place to encourage students interested in pursuing graduate studies to begin their research-related activities while still registered as an undergraduate student. While enrolled in this option, a student may complete some of the M.Eng. degree requirements and, therefore, potentially be able to graduate earlier from the M.Eng. program. Students who have gone through the program all agree that being able to complete a master's degree in a shorter period of time is an advantage.\n\nStudents can enroll in the M.Eng. fast track option concurrently with their undergraduate program the fall semester prior to starting academic term 8. Prior to entering the fast-track option, students must apply for and receive an exemption from work term 6. While enrolled in the option a student must be registered in full-time graduate studies during the fall semester prior to academic term 8. During academic term 8, the student must take a leave of absence from the graduate program while he/she completes the B.Eng. program.\n\nIn the fall semester following academic term 7, fast track students will pay only the graduate fees appropriate to graduate students following plan A or the 6 semester plan. In the succeeding winter semester, while completing academic term 8 of their undergraduate program, fast-track students will pay only the appropriate undergraduate fees.\n\nUpon completion of their undergraduate program, students may register in the M.Eng. program on a full-time basis. All courses taken as part of the graduate program while enrolled in the M.Eng. fast-track option are credited towards the M.Eng. degree course requirements. Courses taken as credit towards a student’s undergraduate degree may not be credited towards a student’s graduate degree and vice versa.",
    tabThreeAdmission: "To be considered for admission to the Master of Applied Science in Software Engineering (MASc.SE), applicants should have a four-year undergraduate degree (or equivalent) in computer science, computer engineering or a cognate area, from a university of recognized standing.\n\n- 4-year Bachelor Degree in Relevant Disciplines with CGPA 3.0/4\n- Academic Transcript\n- Medium of Instruction Letter (Stating Your Degree Was Taught in English)\n- 2 Recommendation Letters from Professors or Assistant Professors\n- Updated Resume / CV\n- Experience Letter (If Applicable)\n- Statement of Purpose (SOP)\n- Application Fee of $120\n- IELTS 6.5 or Above (If Applicable)",
    tabFourProgramLink: "https://www.mun.ca/engineering/graduate/programs/software-engineering/",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: `The Master of Applied Science (MASc) in Computer Engineering is a course-based graduate program that prepares graduates for further postgraduate study or careers as computer engineers in sectors such as telecommunications, information technology, software development, and digital hardware design. The degree provides participants with a balanced background in computer hardware and software, along with in-depth knowledge of key application areas including software development, hardware design, telecommunication systems, computer networks, and parallel computing. 
The duration of this program is approximately 2 years.`,

    programOverview: [],
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$30,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    },
    courseReqText:
      "The total credit requirement for this program is 33 credit hours. Courses are divided into core, elective, and project components. The project is completed in the final two semesters, while core courses provide foundational knowledge and electives allow specialization.",

    courseRequirement: {
      projectCourses: {
        title: "Computer Engineering Project (3 credit hours)",
        courses: [
          "ENGI 981A Computer Engineering Project A (zero credit hours)",
          "ENGI 981B Computer Engineering Project B (three credit hours)"
        ]
      },

      coreCourses: {
        title: "Five Core Courses (3 credit hours each)",
        courses: [
          "ENGI 9818 Computer Software Foundations",
          "ENGI 9819 Computer Hardware Foundations",
          "ENGI 9865 Advanced Digital Systems",
          "ENGI 9867 Advanced Computing Concepts for Engineering",
          "ENGI 9874 Software Design and Specification"
        ]
      },

      electiveCourses: {
        title: "Five Elective Courses (3 credit hours each)",
        courses: [
          "ENGI 9804 Industrial Machine Vision",
          "ENGI 9823 Computer Security",
          "ENGI 9861 High-Performance Computer Architecture",
          "ENGI 9868 ASIC Design",
          "ENGI 9869 Advanced Concurrent Programming",
          "ENGI 9871 Information Theory and Coding",
          "ENGI 9872 Digital Communications",
          "ENGI 9875 Embedded and Real-Time Systems Design",
          "ENGI 9876 Advanced Data Networks",
          "ENGI 9877 Cryptography"
        ]
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a minimum second-class engineering degree (or equivalent) from a university of recognized standing.",

      admissionInfo: [
        "Intake: September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ]
    },

    programLink:
      "Computer Engineering | Faculty of Engineering and Applied Science | Memorial University of Newfoundland"

  },
  {
    id: "2",
    targetId: "deve",
    category: "Business",
    imgUrl: internationalBuis,
    courseTitle: "MBA - In International Business",
    courseDesc:
      "This program prepares leaders to manage diverse teams, lead global organizations, and navigate the fast-changing landscape of global business.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "3",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: dataAnalytics,
    courseTitle:
      "Master of Science in Big Data Analytics - Applied Modelling and Quantitative Methods",
    courseDesc:
      "You will be uniquely prepared with tools to work with and analyze complex data sets in sciences and business.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },

  {
    id: "5",
    targetId: "desi",
    category: "Engineering",
    imgUrl: software,
    courseTitle: "MASc - Software Engineering",
    courseDesc: `
Specialize in Software Engineering: Gain core knowledge for roles in software development, systems architecture, design, and related areas.`,
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Applied Science in Software Engineering (MASc.SE) is a course-based master’s program intended for students with a computer science or computer engineering background who wish to specialize further in software engineering. It is a four-term program offered jointly by the Faculty of Engineering and Applied Science and the Faculty of Science. Graduates of the program gain strong knowledge and understanding of core areas and methods in software engineering.",
    paragraph2: "They are well prepared for roles in software development, computer systems architecture and design, and distributed services. The program distinguishes itself from other computer science and computer engineering options by placing greater emphasis on software engineering and related topics, while reducing focus on areas such as hardware, digital design, and communications.",
    programOverview: [],
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$30,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    },
    courseReqText:
      "The program consists of 30 credit hours, including 21 credit hours of core courses and 9 credit hours of elective courses (subject to program chair approval).",

    courseRequirement: {
      coreCourses: {
        title: "Seven Core Courses (3 credit hours each)",
        courses: [
          "ENGI 9818 Software Foundations",
          "ENGI 9867 Advanced Computing Concepts for Engineering",
          "ENGI 9874 Software Design and Specification",
          "ENGI 9839 Software Verification and Validation",
          "ENGI 9837 Software Engineering Capstone",
          "COMP 6901 Applied Algorithms",
          "COMP 6905 Software Engineering"
        ]
      },

      electiveCourses: {
        title: "Elective Courses (9 credit hours total)",
        courses: [
          "ENGI 9823 Computer Security or COMP 6916 Security and Privacy",
          "ENGI 9838 Software Engineering Practice",
          "ENGI 9861 High-performance Computer Architecture or COMP 6904 Advanced Computer Architecture",
          "ENGI 9869 Advanced Concurrent Programming or COMP 6903 Concurrent Computing",
          "ENGI 9872 Digital Communications",
          "ENGI 9875 Embedded and Real-time Systems Design or COMP 6925 Advanced Operating Systems",
          "ENGI 9876 Advanced Data Networks",
          "ENGI 9877 Cryptography",
          "COMP 6908 Database Technology and Applications",
          "COMP 6910 Services Computing, Semantic Web and Cloud Computing",
          "COMP 6921 Syntax and Semantics of Programming Languages",
          "COMP 6922 Compiling Methods",
          "COMP 6934 Introduction to Data Visualization",
          "AI 6001 Topics in Artificial Intelligence"
        ]
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a minimum second-class engineering degree (or equivalent) from a university of recognized standing.",

      admissionInfo: [
        "Intake: September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ]
    },

    programLink:
      "Software Engineering | Faculty of Engineering and Applied Science | Memorial University of Newfoundland"
  },

  {
    id: "7",
    targetId: "desi",
    category: "Engineering",
    imgUrl: energySystem,
    courseTitle: "MASc - Energy Systems Engineering",
    courseDesc:
      "Explore Energy Systems Engineering to drive innovation in sustainable energy solutions, addressing global demands and environmental concerns.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: `Energy Systems Engineering is a critical area in need of innovation and highly qualified personnel.`,
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$26,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based",
    },
    paragraph2: `The need for readily available and high quality energy is expanding in Newfoundland and Labrador and globally, which has created a worldwide demand for professional training at the graduate level in areas related to the energy industry. The demand for sustainable energy, as well as the environmental concerns of traditional techniques requires significant innovation in energy systems engineering.`,
    paragraph3: `To develop more sustainable techniques requires research and innovation to achieve energy production and utilization that is financially viable, readily available and environmentally benign. This program is inter-disciplinary. It addresses the complexity and required expertise in several technical disciplines by the industry.`,

    pointText: "",
    programOverview: [],

    courseReqText:
      "Students must complete 30 credit hours of course work, including five core courses, three elective courses, and a six-credit-hour project completed over the final two semesters. The program offers two streams: Energy Conversion Technical Stream and Power Systems Technical Stream.",

    courseRequirement: {
      streams: {
        energyConversion: {
          title: "Energy Conversion Technical Stream",
          description:
            "Focuses on energy generation and utilization. Designed for students with backgrounds in mechanical, chemical, industrial, or related engineering disciplines.",

          projectCourses: [
            "ENGI 990A MESE Project Course",
            "ENGI 990B Continuation of MESE Project Course"
          ],

          coreCourses: [
            "ENGI 9853 Energy Economics and Policy",
            "ENGI 9854 Fundamentals of Energy Systems",
            "ENGI 9855 Energy and the Environment",
            "ENGI 9856 Electrical Power Systems",
            "ENGI 9909 Advanced Thermodynamics"
          ],

          electiveCourses: [
            "ENGI 9420 Engineering Analysis",
            "ENGI 9841 Thermal Power Plants",
            "ENGI 9843 Solar Engineering",
            "ENGI 9845 Energy Storage",
            "ENGI 9977 Computational Fluid Dynamics",
            "ENGI 9985 Advanced Heat Transfer",
            "ENGI 9901 Fundamentals of Fluid Dynamics"
          ]
        },

        powerSystems: {
          title: "Power Systems Technical Stream",
          description:
            "Focuses on electrical aspects of energy engineering. Designed for students with backgrounds in electrical engineering or related disciplines.",

          projectCourses: [
            "ENGI 990A MESE Project Course",
            "ENGI 990B Continuation of MESE Project Course"
          ],

          coreCourses: [
            "ENGI 9853 Energy Economics and Policy",
            "ENGI 9854 Fundamentals of Energy Systems",
            "ENGI 9855 Energy and the Environment",
            "ENGI 9857 Instrumentation and Control of Energy Systems",
            "ENGI 9858 Advanced Power Systems"
          ],

          electiveCourses: [
            "ENGI 9420 Engineering Analysis",
            "ENGI 9841 Thermal Power Plants",
            "ENGI 9843 Solar Engineering",
            "ENGI 9845 Energy Storage",
            "ENGI 9896 Renewable Energy Systems",
            "ENGI 9862 Power System Protection",
            "ENGI 9863 Grid Integration of Energy Systems"
          ]
        }
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a minimum second-class engineering degree (or equivalent) from a university of recognized standing.",

      admissionInfo: [
        "Intake: September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ]
    },

    programLink:
      "Energy Systems Engineering | Faculty of Engineering and Applied Science | Memorial University of Newfoundland"
  },
  {
    id: "8",
    targetId: "desi",
    category: "Engineering",
    imgUrl: environmental,
    courseTitle: "Environmental Systems Engineering and Management",
    courseDesc:
      "Embark on a transformative journey in Environmental Engineering. Gain comprehensive education and interdisciplinary expertise to address complex environmental issues.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: `Environmental engineering has become an increasingly important discipline due to the complexity and multidisciplinary nature of environmental issues related to human health and ecosystem protection. To develop cost-effective engineering solutions to these challenges, it is essential to acquire a broad-based education and professional training in interdisciplinary fields, including physical, chemical, and biological principles, resource management, and mitigation measures, along with in-depth knowledge of environmental engineering.`,
    paragraph2: "This course-based program covers a wide range of topics, including environmental law and management, human health and ecological risk assessment, remediation technology, drinking water and wastewater treatment processes, contaminant transport and environmental modeling, environmental sampling, and pollution control engineering. To apply classroom and laboratory concepts, students will work in teams on an engineering project over two terms, and they are encouraged to take courses from other disciplines to gain a broader understanding of the field.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "January/September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$26,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    },
    programOverview: [],
    courseReqText:
      "The total credit requirement to complete this course-based program is 30 credit hours and will be taken from the following three groups.",

    courseRequirement: {
      projectCourses: {
        title: "Environmental Engineering Project (six credit hours)",
        courses: [
          "ENGI 960A Environmental Engineering Project A (zero credit hours)",
          "ENGI 960B Environmental Engineering Project B (six credit hours)"
        ]
      },

      coreCourses: {
        title: "Five Core Courses (Three credit hours each)",
        courses: [
          "ENGI 9601 Environmental Pollution and Mitigation",
          "ENGI 9609 Environmental Risk Assessment",
          "ENGI 9626 Environmental Management System",
          "ENGI 9627 Environmental Systems Engineering",
          "ENGI 9628 Environmental Laboratory"
        ]
      },

      electiveCourses: {
        title: "Three Elective Courses (Three credit hours each)",
        courses: [
          "ENGI 9605 Water and Wastewater Treatment",
          "ENGI 9621 Soil Remediation Engineering",
          "ENGI 9622 Environmental Statistics",
          "ENGI 9624 Air Pollution",
          "ENGI 9625 Environmental Impacts of Offshore Oil and Gas Operations",
          "ENGI 9629 Environmental Policy and Regulations",
          "ENGI 9630 Pollution Prevention",
          "ENGI 9797 Climate Change and Water Resources Sustainability",
          "ENVS 6001 Earth and Ocean Sciences",
          "ENVS 6002 Environmental Chemistry & Toxicology",
          "ENVS 6003 Applied Ecology"
        ]
      }
    },

    admissionRequirements: {
      description:
        "Admission is competitive and selective. Applicants must have a minimum second-class four-year undergraduate degree (or equivalent) in environmental engineering, applied environmental science, civil engineering, chemical engineering, biological engineering, or another relevant field from a recognized university.",

      admissionInfo: [
        "Intake: Winter & September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ]
    },

    programLink:
      "Environmental Systems Engineering and Management | Faculty of Engineering and Applied Science | Memorial University of Newfoundland"
  },
  {
    id: "9",
    targetId: "desi",
    category: "Engineering",
    imgUrl: oilGas,
    courseTitle: "MASc - Oil and Gas Engineering",
    courseDesc:
      "Explore the oil and gas industry with our Master in Oil and Gas Engineering program, covering sustainable development, environmental protection, and more.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: `The oil and gas industry is complex and requires expertise across multiple technical disciplines. To meet this demand, the Faculty of Engineering and Applied Science offers a multidisciplinary, course-based program in Oil and Gas Engineering (OGE). The program provides the latest technical knowledge on upstream, production, and downstream aspects of the industry, while also addressing key challenges such as sustainable development, environmental protection, risk, reliability, and safety. It covers areas including drilling engineering, phase behavior of petroleum fluids, production engineering, compact process equipment design, offshore environmental operations, and natural gas engineering. Many courses are supported by field studies and laboratory demonstrations.`,
    paragraph2: "To apply theoretical knowledge, students work in teams on an engineering project over two terms. The program can be completed on a full-time or part-time basis, with the full-time option typically taking 1–2 years to complete.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "January/September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$26,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    },
    programOverview: [],
    courseReqText:
      "The total credit requirement to complete this course-based program is 30 credit hours and will be taken from the following three groups.",

    courseRequirement: {
      projectCourses: {
        title: "Oil and Gas Engineering Project (six credit hours)",
        courses: [
          "ENGI 910A Oil and Gas Engineering Project Course (zero credit hour)",
          "ENGI 910B Oil and Gas Engineering Project Course (six credit hours)"
        ]
      },

      coreCourses: {
        title: "Five Core Courses (Three credit hours each)",
        courses: [
          "ENGI 9110 Advanced Petroleum Production Engineering",
          "ENGI 9113 Phase Behaviour of Petroleum Reservoir Fluids",
          "ENGI 9114 Advanced Reservoir Engineering",
          "ENGI 9118 Advanced Drilling Engineering",
          "ENGI 9121 Advanced Safety, Risk and Reliability Modeling"
        ]
      },

      electiveCourses: {
        title: "Three Elective Courses (Three credit hours each)",
        courses: [
          "ENGI 9002 Ocean Engineering Structures",
          "ENGI 9015 Ocean Engineering Hydrodynamics",
          "ENGI 9111 Well Testing",
          "ENGI 9112 Multiphase Flow",
          "ENGI 9115 Safety and Risk Engineering",
          "ENGI 9116 Reliability Engineering",
          "ENGI 9117 Offshore Petroleum Geology and Technology",
          "ENGI 9119 Compact Process Equipment Design",
          "ENGI 9120 Advanced Natural Gas Engineering",
          "ENGI 9310 Advanced Reactor Analysis and Bioreactors",
          "ENGI 9320 Advanced Separation Processes",
          "ENGI 9420 Engineering Analysis",
          "ENGI 9609 Environmental Risk Assessment",
          "ENGI 9624 Air Pollution",
          "ENGI 9625 Environmental Impacts of Offshore Oil and Gas Operations",
          "ENGI 9901 Fundamentals of Fluid Dynamics",
          "ENGI 99XX Special Topics – Corrosion Principles, Prevention and Control"
        ]
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a minimum second-class engineering degree (or equivalent) from a university of recognized standing.",

      admissionInfo: [
        "Intake: Winter & September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ]
    },

    programLink:
      "Oil and Gas Engineering | Faculty of Engineering and Applied Science | Memorial University of Newfoundland"
  },
  {
    id: "22",
    targetId: "desi",
    category: "Engineering",
    imgUrl: eng2,
    courseTitle: "Master in Sustainable Infrastructure Engineering",
    courseDesc:
      "This program equips them with the necessary skills to develop, operate, and maintain sustainable infrastructure systems - buildings, bridges, dams, drinking water, drainage and sewer systems, waste management, power supply facilities, etc.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    programOverview: [],
    courseExp: "",
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$26,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    }
  },
  {
    id: "10",
    targetId: "desi",
    category: "Engineering",
    imgUrl: safetyRisk,
    courseTitle: "MASc - Safety and Risk Engineering",
    courseDesc:
      "Master in Safety and Risk Engineering for professionals, offering skills for real-world applications in hazardous facilities, and introducing recent analytical techniques.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: `Safety and risk concerns are of paramount importance in a wide variety of complex engineering activities such as offshore operations, 
petroleum refining and mineral processing. Today, there is a wide range of techniques available to assess safety, risk and reliability, 
both in relation to design as well as day-to-day operations. The use of these techniques is now an integral part of safety-related regulations of 
hazardous facilities and operations. Memorial University's MASc. and graduate diploma programs in safety and risk engineering are designed to give a 
thorough understanding of these techniques and their application to a variety of real-world problems. The discipline is the only one of its kind in Canada.
`,
    paragraph2: `
It aims to provide students with a good grounding in safety and risk engineering in both a qualitative and quantitative manner, and to develop the skills to 
apply this understanding. The programs will also introduce students to recent developments in analytical techniques, such as computer modelling of risk, 
reliability and safety problems, dynamic risk analysis, etc.`,
    paragraph3: `The programs are intended for, though not limited to, working professionals to advance their understanding and skill related to safety and risk engineering.  
The knowledge acquired through the programs will enhance the skills of engineers in the process industries, oil and gas service and operating companies, mineral 
processing, engineering consultants and government services. The programs build around the knowledge and understanding of accident modelling, process and 
offshore safety issues. Engineering and human factors associated with the safety and risk assessment will also be covered.`,
    pointText: "The following topics will be covered in detail in different courses of the programs:",
    programOverview: [
      "Human factor assessment",
      "Reliability assessment",
      "Structural safety and integrity assessment",
      "Quantitative risk assessment and management",
      "Probabilistic risk modeling and its application in safety and structure design",
      "Environment risk assessment",
      "Risk-based asset integrity assessment and management",
      "Risk-based safety measure design",
      "Program requirements",
      "Accident modelling",
      "Process safety",
      "Electrostatic hazards and their prevention",
      "Safety instrumented system",
      "Offshore safety",
      "Fire and explosion engineering",
      "Emergency situation assessment and management",
    ],
    courseReqText: "The total credit requirement to complete this course-based program is 30 credit hours and will be taken from the following three groups.",
    courseRequirement: {
      projectCourses: {
        title: "Safety and Risk Engineering Project (Six credit hoursSix credit hours)",
        courses: [
          "ENGI 915A Safety and Risk Engineering Project Course Zero credit hour",
          "ENGI 915B Safety and Risk Engineering Project Course (Six credit hours)",

        ]
      },
      coreCourses: {
        title: "Five Core Courses (Three credit hours each)",
        courses: [
          "ENGI 9115 Safety and Risk Engineering",
          "ENGI 9116 Reliability Engineering",
          "ENGI 9121 Advanced Safety and Risk Engineering",
          "ENGI 9411 Probabilistic Methods in Engineering",
          "ENGI 9330 Abnormal Situation Management, Fault Detection and Analysis"
        ]
      },

      electiveCourses: {
        title: "Three Elective Courses (Three credit hours each)",
        courses: [
          "ENGI 9516 Similitude, Modelling and Experimental Data Analysis",
          "ENGI 9609Environmental Risk Assessment",
          "ENGI 9622Environmental Statistics",
          "ENGI 9899Special Topics – Corrosion Principles, Prevention and Control",
          "ENGI 9625Environmental Impacts of Offshore Oil and Gas Operations",
          "ENGI 9340Material Degradation and Asset Management",
          "ENGI 9977Computational Fluid Mechanics"
        ]
      }
    },
    admissionRequirements: {
      description:
        "To be considered for admission, the minimum requirements will normally be a second-class engineering degree from a university of recognized standing.",
      admissionInfo: [
        "Intake: January & September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English is the Medium of Instruction Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)"
      ],

    },
    courseDetail: {
      stydyLevel: "Master",
      intake: "January & September",
      deadline: "30 March",
      duration: "2 years",
      fees: "C$26,000 (2 Years)",
      applicationFee: "C$120 ",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    }
  },
  {
    id: "11",
    targetId: "deve",
    category: "Business",
    imgUrl: technologyManagement,
    courseTitle:
      "MA In Leadership & MSc In Information Technology and Management",
    courseDesc:
      "Join the Dual Track Master's program to earn TWU's MA in Leadership and Belhaven University's MS in Information Technology Management simultaneously.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "12",
    targetId: "deve",
    category: "Business",
    imgUrl: businessHealth,
    courseTitle:
      "MA In Leadership - Specialization In Education, Business, or Health",
    courseDesc:
      "This program develops emerging leaders as confident and effective servant-leaders for the 21st Century, focusing on Transformational Servant and Values-Based Leadership.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "13",
    targetId: "deve",
    category: "Business",
    imgUrl: changeManagement,
    courseTitle: "Master of Management -  Strategic Change Management",
    courseDesc:
      "The Strategic Change Management stream of the Master of Management program prepares graduates for managerial careers in evolving business environments.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "14",
    targetId: "deve",
    category: "Business",
    imgUrl: management,
    courseTitle: "Master of Management ",
    courseDesc:
      "This master's program offers a competitive edge in the job market with a broad spectrum of business disciplines, from accounting to strategic management.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "15",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: financialAnalytics,
    courseTitle:
      "Master of Science in Big Data Financial Analytics - Applied Modelling and Quantitive Methods afdsdfsdf sdf",
    courseDesc:
      "Focus on financial analysis theories and techniques for careers in equity analysis, investment banking, portfolio management, and other financial sector opportunities.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "16",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: it,
    courseTitle: "Master of Science in Forensic Science",
    courseDesc: `Enhance your expertise in forensic science with our professional program. Gain hands-on experience, develop communication skills, and explore research-practice nexus.`,
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "17",
    targetId: "arts",
    category: "Art & Design",
    imgUrl: artDesignEng,
    courseTitle: "Master of Arts In English ",
    courseDesc: `
Earn a Master’s in English (Public Texts) at Trent in just a year. Explore careers in communications, editing, teaching, or scholarship.`,
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "18",
    targetId: "arts",
    category: "Art & Design",
    imgUrl: artDesign,
    courseTitle: "Master of Arts in Sustainability Studies",
    courseDesc:
      "Lead change through Sustainability Studies at the University, addressing environmental, economic, social, and cultural challenges with interdisciplinary exploration",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "19",
    targetId: "arts",
    category: "Art & Design",
    imgUrl: artDesign2,
    courseTitle: "Master of Arts Management with 4 Months Paid Co-op",
    courseDesc:
      "The Master of Management program offers three professional streams. The program is 16 months followed by a workplace internship in the fourth term.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },

  {
    id: "20",
    targetId: "health",
    category: "Health Science",
    imgUrl: health1,
    courseTitle: "Master of Instrumental Chemical Analysis with 4 Months Paid Co-op",
    courseDesc:
      "In this 12-month Master's in Instrumental Chemical Analysis with co-op, students have the opportunity to get hands-on, industry experience through paid.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "20",
    targetId: "health",
    category: "Health Science",
    imgUrl: health3,
    courseTitle: "Master of Management: Health Care Management with 4 months",
    courseDesc:
      "Prepares graduates for managerial careers in dynamic and complex healthcare sector.......",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },
  {
    id: "21",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: it2,
    courseTitle: "Master of Science in Applied Modelling: Data Science & Analytics",
    courseDesc:
      "Students learn the tools and techniques needed to handle and analyze complex data sets across various scientific and social science fields.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
  },






  {
    id: "101",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: masterOfArtificalIng,
    courseTitle: "Master of Artificial Intelligence Design & Development",
    courseDesc:
      "The Master of Artificial Intelligence Design & Development program equips you with the expertise to excel in the fast-moving space of artificial intelligence.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Artificial Intelligence Design & Development program equips you with the expertise to excel in the fast-moving space of artificial intelligence (AI), bridging the gap between rigorous theory and real-world business solutions.",
    paragraph2: "Through advanced training in machine learning, natural language processing, computer vision, ethics in AI and more, you will be prepared to develop and apply AI technologies across multiple industries. You will learn to design and refine high-performing machine learning models, evaluate conventional, auto and real-time machine learning algorithms for different use cases and generate actionable insights from deep learning models to drive business innovation.",
    paragraph3: "The program offers extensive experiential learning opportunities to help you gain industry experience. You will participate in case analyses and innovative labs, alongside an independent applied research project and eight months of internship experience.",
    pointText: "Our master's in artificial intelligence design & development will prepare you with skills and career opportunities in the following areas:",
    programOverview: [
      "Artificial Intelligence (AI)",
      "Machine Learning (ML)",
      "Deep Learning",
      "Natural Language Processing (NLP)",
      "Computer Vision",
      "Machine Learning Operations (MLOps)",
      "Data Science for AI",
      "Applied research",
      "Complex problem solving and analysis",
      "Critical thinking",
      "Ethics in AI",
      "AI Project Management",
      "AI Engineer",
      "AI Project Manager",
      "AI Manager",
      "Data Analyst",
      "Data Scientist",
      "Deep Learning Engineer",
      "Lead Data Engineer",
      "Machine Learning Software Engineer"
    ],
    courseReqText: "In this program, you will have the opportunity to participate in 840 hours of work-integrated learning experience in your final two semesters of study. This can be completed either as two unique four-month internships or one eight-month internship.",
    courseRequirement: {
      projectCourses: {
        title: "Internship",
        courses: [
          "840 hours of work-integrated learning in the final two semesters",
          "Two unique four-month internships or one eight-month internship",
          "Industry experience developing or implementing an AI application"
        ]
      },
      coreCourses: {
        title: "Skills",
        courses: [
          "Artificial Intelligence (AI)",
          "Machine Learning (ML)",
          "Deep Learning",
          "Natural Language Processing (NLP)",
          "Computer Vision",
          "Machine Learning Operations (MLOps)",
          "Data Science for AI",
          "Applied research",
          "Complex problem solving and analysis",
          "Critical thinking",
          "Ethics in AI",
          "AI Project Management"
        ]
      },
      electiveCourses: {
        title: "Career Opportunities",
        courses: [
          "AI Engineer",
          "AI Project Manager",
          "AI Manager",
          "Data Analyst",
          "Data Scientist",
          "Deep Learning Engineer",
          "Lead Data Engineer",
          "Machine Learning Software Engineer"
        ]
      }
    },
    admissionRequirements: {
      description: "To be considered for admission, the minimum requirements will normally be the following.",
      admissionInfo: [
        "Intake: January & September (Each Year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English is the Medium of Instruction Letter",
        "2 Reference / Recommendation Letters from Professor or Assistant Professor",
        "IELTS 6.5 (If Applicable)",
        "PTE 60 (If Applicable)",
        "Degree Assessment: WES (World Education Services) or ICAS (International Credential Assessment Service)"
      ]
    },
    internShipParagraph1:"In this program, you will have the opportunity to participate in 840 hours of work-integrated learning experience in your final two semesters of study. This can be completed either as two unique four-month internships or one eight-month internship. The internship is designed to build upon experiential and theoretical learning in an industry setting, where you will engage in the development or implementation of an AI application.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "Jan & Sep",
      deadline: "N/A",
      duration: "16 Months",
      fees: "$40,000 (For 16 Months)",
      applicationFee: "$90",
      language: "English",
      courseDelivery: "Hybrid",
      courseRoute: "Course Based"
    }
  },
  {
    id: "102",
    targetId: "arts",
    category: "Business",
    imgUrl: masterOfAppliedEconomics,
    courseTitle: "Master of Applied Economics and Policy",
    courseDesc:
      "The Master of Applied Economics and Policy program prepares students for careers in economic policy through a unique combination of courses.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Applied Economics and Policy (MAEP) program at the University of Windsor is a graduate-level degree designed to equip students with practical skills in economic analysis and policy-making. The program focuses on applying economic theories to real-world issues, particularly in government and business environments. It aims to bridge the gap between theoretical knowledge and practical application, enabling students to make informed decisions and contribute to effective policy development.",
    paragraph2: "The program typically spans 16 months and includes a combination of core courses, electives, and a research-based policy project. Students gain strong foundations in applied microeconomics, macroeconomics, econometrics, and quantitative methods. A key component of the program is training in data analysis, allowing students to interpret large datasets and use evidence-based approaches to solve economic and policy challenges.",
    paragraph3: "Graduates of this program are prepared for careers in government agencies, private sector organizations, consulting firms, and international institutions. It is particularly suited for individuals seeking to enter the professional workforce with advanced economic expertise rather than pursuing academic research or a PhD. The program emphasizes developing analytical and problem-solving skills to assess policies and their impact on economic and social outcomes.",
    pointText: "Students develop practical economic and policy knowledge in the following areas:",
    programOverview: [
      "Applied economic analysis",
      "Policy-making for government and business environments",
      "Applied microeconomics and macroeconomics",
      "Econometrics and quantitative methods",
      "Data analysis for large datasets",
      "Evidence-based policy evaluation",
      "Research-based policy project",
      "Career preparation for government, consulting, private sector, and international institutions"
    ],
    courseReqText: "The program may include internship or practical learning opportunities that allow students to gain real-world experience in government, business, or policy organizations.",
    courseRequirement: {
      projectCourses: {
        title: "Internship / Practical Learning",
        courses: [
          "Real-world experience in government, business, or policy organizations",
          "Applied economic knowledge in professional settings",
          "Professional skill-building to improve employability after graduation"
        ]
      },
      coreCourses: {
        title: "Topics Covered",
        courses: [
          "Applied Microeconomics",
          "Applied Macroeconomics",
          "Econometrics & Statistical Methods",
          "Data Analysis & Interpretation",
          "Public Policy Analysis",
          "Economic Modeling & Forecasting",
          "Cost-Benefit Analysis",
          "Financial & Business Economics",
          "International Economics & Trade",
          "Research Methods in Economics",
          "Quantitative Techniques & Mathematics",
          "Policy Project / Capstone Research"
        ]
      },
      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Data analysis & econometrics",
          "Policy analysis & evaluation",
          "Critical thinking & problem-solving",
          "Quantitative & mathematical skills",
          "Economic modeling & forecasting",
          "Communication through reports & presentations",
          "Research skills",
          "Project management",
          "Decision-making using data",
          "Understanding of public & business policy"
        ]
      }
    },
    admissionRequirements: {
      description: "Admission requirements for the Master of Applied Economics and Policy include academic preparation, prerequisite economics courses, and supporting documents.",
      admissionInfo: [
        "A 4-year undergraduate degree (or equivalent)",
        "Minimum 70% CGPA (or equivalent) in the last two years of study",
        "Completion of prerequisite courses in Microeconomics, Macroeconomics, and Statistics / Econometrics",
        "English language proficiency for international students: IELTS 6.5 overall, TOEFL iBT 83 minimum, or Duolingo 120 minimum",
        "Statement of Interest (max 2 pages)",
        "Curriculum Vitae (CV) (max 2 pages)",
        "Official academic transcripts",
        "Proof of English proficiency (if applicable)"
      ]
    },
    internShipParagraph1 :"The program may include internship or practical learning opportunities that allow students to gain real-world experience in government, business, or policy organizations. These experiences help students apply their economic knowledge, build professional skills, and improve their employability after graduation.",
    courseDetail: {
      stydyLevel: "Master's Degree",
      intake: "September",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 27,000 - 31,000 for full program",
      applicationFee: "CAD 125 (non-refundable)",
      language: "English",
      courseDelivery: "On-Campus",
      courseRoute: "Course Based"
    }
  },
  {
    id: "103",
    targetId: "sci",
    category: "Science",
    imgUrl: masterofActuarialScience,
    courseTitle: "Master of Actuarial Science",
    courseDesc:
      "Master of Actuarial Science is a 16-month, 12-course professional program designed to prepare students for SOA professional exams and careers in insurance, pension, and risk management.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Actuarial Science at the University of Windsor is a professional, course-based graduate program designed to prepare students for careers in actuarial science, risk management, and financial analysis. The program focuses on developing strong analytical and quantitative skills required in insurance, finance, and pension industries. It is structured to align with international actuarial standards, especially the Society of Actuaries (SOA) exams, making it highly career-oriented.",
    paragraph2: "This program emphasizes practical application of mathematics, statistics, and financial theory to solve real-world problems related to risk and uncertainty. Students are trained to analyze financial risks, evaluate insurance models, and support decision-making in complex economic environments. The curriculum is designed to bridge academic knowledge with industry requirements, ensuring graduates are job-ready for actuarial and financial sectors.",
    paragraph3: "Overall, the program is ideal for students who want to build a strong foundation in actuarial methods and pursue professional certification while gaining advanced technical expertise in risk assessment and financial modeling.",
    pointText: "Students develop career-ready actuarial, risk, and financial analysis skills in the following areas:",
    programOverview: [
      "Actuarial science",
      "Risk management",
      "Financial analysis",
      "Insurance and pension industries",
      "Society of Actuaries (SOA) exam preparation",
      "Risk assessment",
      "Financial modeling",
      "Decision-making under uncertainty"
    ],
    courseReqText: "The program may include practical training or internship opportunities in insurance companies, banks, consulting firms, and financial institutions.",
    courseRequirement: {
      projectCourses: {
        title: "Internship / Practical Training",
        courses: [
          "Practical opportunities in insurance companies, banks, consulting firms, and financial institutions",
          "Application of actuarial concepts in real business environments",
          "Hands-on exposure to risk assessment, pricing models, and financial forecasting"
        ]
      },
      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Probability Theory & Statistical Methods",
          "Actuarial Mathematics (Life Contingencies)",
          "Financial Mathematics & Interest Theory",
          "Risk Management & Insurance Models",
          "Survival Models & Stochastic Processes",
          "Financial Economics for Actuaries",
          "Data Analysis & Predictive Modeling",
          "Exam preparation courses aligned with SOA requirements",
          "Computational methods using actuarial software"
        ]
      },
      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Actuarial modeling & risk analysis",
          "Probability & statistical analysis",
          "Financial mathematics & investment calculations",
          "Insurance pricing & reserving techniques",
          "Data analysis & predictive modeling",
          "Use of actuarial software & programming tools",
          "Financial risk management",
          "Problem-solving & logical reasoning",
          "Preparation for professional SOA actuarial exams",
          "Decision-making under uncertainty"
        ]
      }
    },
    admissionRequirements: {
      description: "Admission requirements for the Master of Actuarial Science include strong quantitative preparation and standard graduate application documents.",
      admissionInfo: [
        "A 4-year undergraduate degree (or equivalent)",
        "Strong background in mathematics, statistics, or related quantitative field",
        "Minimum required academic standing of 70%",
        "Completion of prerequisite courses such as Calculus, Linear Algebra, Probability & Statistics",
        "English: IELTS 6.5 overall (no band less than 6.0) or TOEFL iBT around 83+",
        "Statement of Interest / Purpose Letter",
        "CV (Resume)",
        "Academic transcripts",
        "Letters of recommendation (if required)"
      ]
    },
    internShipParagraph1:"The program may include practical training or internship opportunities in insurance companies, banks, consulting firms, and financial institutions. These internships allow students to apply actuarial concepts in real business environments, particularly in risk assessment, pricing models, and financial forecasting. This hands-on experience helps students develop industry exposure, professional skills, and improves employment prospects after graduation.",
    courseDetail: {
      stydyLevel: "Master's Degree",
      intake: "September",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 18,400 - 23,000 per year",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus, full-time, course-based program",
      courseRoute: "Course Based"
    }
  },
  {
    id: "104",
    targetId: "deve",
    category: "Business",
    imgUrl: masterofBusinessdministration,
    courseTitle: "Master of Business Administration",
    courseDesc:
      "The Odette 16-month full-time Master of Business Administration provides students with personalized preparation for a successful career in business.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Business Administration (MBA) at the University of Windsor is a full-time, 16-month professional graduate program designed to build strong business, leadership, and analytical skills. The program focuses on experiential learning where students work on real business problems through case studies, projects, and industry collaborations. It welcomes students from both business and non-business backgrounds, making it suitable for a diverse group of learners.",
    paragraph2: "The MBA emphasizes practical learning through small class sizes and direct interaction with faculty. Students are exposed to real-world business challenges in areas such as finance, marketing, accounting, operations, and strategy. The program is structured to develop leadership abilities and prepare students for managerial roles in different industries.",
    paragraph3: "A key feature of the program is its applied approach, where students engage with organizations and industry partners to gain hands-on experience. This helps bridge the gap between academic knowledge and professional practice, making graduates job-ready for competitive business environments.",
    pointText: "The MBA prepares students for business leadership through the following areas:",
    programOverview: [
      "Business leadership",
      "Analytical decision-making",
      "Experiential learning",
      "Case studies and projects",
      "Industry collaboration",
      "Finance, marketing, accounting, operations, and strategy",
      "Managerial career preparation",
      "Hands-on work with organizations and industry partners"
    ],
    courseReqText: "The MBA program includes experiential learning opportunities such as consulting projects, industry-based assignments, and optional work placements or internships.",
    courseRequirement: {
      projectCourses: {
        title: "Internship / Practical Learning",
        courses: [
          "Consulting projects",
          "Industry-based assignments",
          "Optional work placements or internships",
          "Real organization problem-solving and strategy recommendations"
        ]
      },
      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Leadership & Organizational Behaviour",
          "Financial Accounting & Management Accounting",
          "Corporate Finance",
          "Marketing Management",
          "Human Resource Management",
          "Business Analytics",
          "Digital Business Systems",
          "Strategic Management",
          "Entrepreneurship & Innovation",
          "Business Ethics & Sustainability",
          "Project Management",
          "Negotiation & Decision Making"
        ]
      },
      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Leadership & team management",
          "Strategic thinking & decision-making",
          "Financial analysis & budgeting",
          "Marketing strategy development",
          "Business analytics & data interpretation",
          "Problem-solving in real business situations",
          "Communication & presentation skills",
          "Project management",
          "Negotiation & conflict management",
          "Entrepreneurship & innovation skills",
          "Organizational behavior understanding",
          "Critical thinking & business planning"
        ]
      }
    },
    admissionRequirements: {
      description: "Admission requirements for the MBA include academic, professional, and English-language documentation.",
      admissionInfo: [
        "A 4-year Bachelor's degree (or equivalent) from a recognized institution",
        "Minimum 70% average (CGPA) in the last 2 years of undergraduate studies",
        "GMAT requirement, which can be waived in some cases such as high GPA or professional certifications",
        "Updated CV / Resume showing education and experience",
        "Statement of Intent / Letter explaining goals and motivation",
        "At least one reference letter (academic or professional)",
        "Interview with MBA admissions team (online or in-person)",
        "English language requirement for international students: IELTS around 7.0 overall, TOEFL iBT around 100, or Duolingo around 120",
        "No strict work experience requirement, but experience is preferred"
      ]
    },
    internShipParagraph1:"The MBA program includes experiential learning opportunities such as consulting projects, industry-based assignments, and optional work placements or internships. Students work with real organizations to solve business problems, develop strategies, and present recommendations. This practical exposure helps students gain industry experience, build professional networks, and improve job readiness after graduation.",
    courseDetail: {
      stydyLevel: "Master's Degree (MBA)",
      intake: "Fall intake only (September)",
      deadline: "N/A",
      duration: "16 months (4 consecutive semesters)",
      fees: "Approx. CAD 40,000 - 50,000 total program cost",
      applicationFee: "CAD 125 (non-refundable)",
      language: "English",
      courseDelivery: "On-campus, full-time",
      courseRoute: "Course-based"
    }
  },
  {
    id: "105",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: appliedComputing,
    courseTitle: "Master of Applied Computing",
    courseDesc:
      "Master of Applied Computing is a professional program that provides students with a solid foundation in industry-oriented practical aspects of computing.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Applied Computing (MAC) at the University of Windsor is a professional, industry-focused graduate program designed to prepare students for careers in the IT and software industry. The program emphasizes practical computing skills, modern software development practices, and real-world problem-solving. It is structured to bridge the gap between academic knowledge and industry requirements.",
    paragraph2: "The program focuses on advanced computing concepts combined with applied learning. Students gain exposure to current technologies, software engineering practices, data systems, and cloud-based solutions. The learning environment is designed to be hands-on, where students work on projects that simulate real industry challenges.",
    paragraph3: "A key feature of the program is its strong industry relevance, with connections to leading tech companies. Students are trained to become job-ready professionals with the ability to work in software development, IT consulting, and technology-driven organizations.",
    pointText: "Students gain professional computing preparation in the following areas:",
    programOverview: [
      "IT and software industry preparation",
      "Practical computing skills",
      "Modern software development practices",
      "Advanced computing concepts",
      "Applied learning",
      "Current technologies",
      "Software engineering practices",
      "Data systems",
      "Cloud-based solutions",
      "Industry-based projects"
    ],
    courseReqText: "The program includes strong practical exposure through industry-based projects and internship opportunities.",
    courseRequirement: {
      projectCourses: {
        title: "Internship / Practical Experience",
        courses: [
          "Industry-based projects",
          "Internship opportunities",
          "Work placements or applied computing projects with companies",
          "Real-world experience in software development, system design, and IT solutions"
        ]
      },
      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Advanced Software Engineering",
          "Advanced Database Systems",
          "Internet Applications & Distributed Systems",
          "Computer Networks & Security",
          "Advanced Systems Programming",
          "Software Design & Architecture",
          "Data Structures & Algorithms (Advanced)",
          "Cloud Computing Concepts",
          "Data Management Systems",
          "Industry-based Project / Capstone Course"
        ]
      },
      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Software development & programming expertise",
          "Problem-solving using algorithms and logic",
          "Database design and management",
          "Cloud computing and distributed systems knowledge",
          "Cybersecurity and networking fundamentals",
          "System design and software architecture",
          "Teamwork in technical projects",
          "Industry-level software development practices",
          "Analytical and technical communication skills",
          "Project-based application of computing knowledge"
        ]
      }
    },
    admissionRequirements: {
      description: "Admission requirements for the Master of Applied Computing include a computing-related academic background and supporting application documents.",
      admissionInfo: [
        "A 4-year Bachelor's degree in Computer Science or a closely related field",
        "Minimum 70% academic standing (or equivalent in last two years of study)",
        "Strong background in programming and mathematics preferred",
        "Statement of Purpose (SOP)",
        "Updated CV / Resume",
        "Two Letters of Recommendation",
        "Interview (if required)",
        "English language proficiency: IELTS 6.5 overall (no band less than 6.0), TOEFL iBT 92+, or Duolingo 120+"
      ]
    },
    internShipParagraph1:"The program includes strong practical exposure through industry-based projects and internship opportunities. Students may participate in work placements or applied computing projects with companies where they gain real-world experience in software development, system design, and IT solutions. This experience helps students build professional skills, industry connections, and improves their chances of employment after graduation.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 40,000 - 50,000 (total program)",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus, full-time",
      courseRoute: "Course-based with project/internship"
    }
  },
  {
    id: "106",
    targetId: "arts",
    category: "Education",
    imgUrl: masterofEducation,
    courseTitle: "Master of Education",
    courseDesc:
      "Elevate your career with the Master of Education program, designed for professionals seeking to advance their careers in education.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Education (M.Ed) in Educational Studies at the University of Windsor is a graduate-level program designed for educators and professionals who want to advance their knowledge in education, leadership, curriculum development, and educational research. The program focuses on improving teaching practices, understanding learning theories, and addressing modern educational challenges such as equity, diversity, and inclusion.",
    paragraph2: "This program offers flexible study options, including course-based, major paper, and thesis streams. Students can also choose different areas of specialization such as Curriculum Studies, Educational Leadership and Administration, or Second Language Acquisition. The structure is designed to support both academic growth and professional development in the field of education.",
    paragraph3: "The program is available in both on-campus and fully online formats, allowing working professionals to continue their studies with flexibility. It emphasizes applied learning, research skills, and practical educational problem-solving to prepare graduates for leadership roles in schools, colleges, and educational organizations.",
    pointText: "Students can build advanced education knowledge and professional skills in the following areas:",
    programOverview: [
      "Education leadership",
      "Curriculum development",
      "Educational research",
      "Teaching practice improvement",
      "Learning theories",
      "Equity, diversity, and inclusion",
      "Curriculum Studies",
      "Educational Leadership and Administration",
      "Second Language Acquisition",
      "Applied learning and research skills"
    ],
    courseReqText: "The program is mainly course-based and research-oriented, so formal internships are not always mandatory. However, students gain practical experience through applied projects, school-based research, and professional assignments.",
    courseRequirement: {
      projectCourses: {
        title: "Internship / Practical Experience",
        courses: [
          "Applied projects",
          "School-based research",
          "Professional assignments",
          "Possible educational work placements or field-based activities depending on specialization and career goals"
        ]
      },
      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Research in Education (methods and research design)",
          "Statistics in Education",
          "Qualitative & Quantitative Research Methods",
          "Curriculum Theory & Development",
          "Educational Leadership & Administration Theory",
          "Language Acquisition & Instruction Methods",
          "Educational Policy and Practice",
          "Assessment & Evaluation in Education",
          "Final Project / Major Paper / Thesis Work"
        ]
      },
      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Educational research design & analysis",
          "Curriculum planning & development",
          "Leadership & administrative decision-making",
          "Data analysis in education",
          "Teaching strategies & instructional design",
          "Policy evaluation in education systems",
          "Critical thinking & reflective practice",
          "Academic writing & research communication",
          "Problem-solving in classroom and institutional settings",
          "Understanding of equity, diversity & inclusive education"
        ]
      }
    },
    admissionRequirements: {
      description: "Admission requirements for the Master of Education include academic preparation, education experience, and supporting documents.",
      admissionInfo: [
        "A 4-year Bachelor's degree (or equivalent)",
        "Minimum 70% academic standing in the last two years of study",
        "At least 1 year of relevant experience in education or training",
        "Statement of Academic Objectives (SOP)",
        "CV / Resume",
        "Selection of specialization area",
        "English language proficiency for international students: IELTS typically 6.5 overall or TOEFL iBT minimum required score as per university standards",
        "Academic transcripts",
        "Reference letters in some cases"
      ]
    },
    internShipParagraph1:"The program is mainly course-based and research-oriented, so formal internships are not always mandatory. However, students gain practical experience through applied projects, school-based research, and professional assignments. Some students may engage in educational work placements or field-based activities depending on their specialization and career goals. This practical exposure helps connect theory with real classroom and institutional practice, especially for those already working in education.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "Fall & Winter",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 20,000 - 30,000 total",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus",
      courseRoute: "Course-based"
    }
  },
  {
    id: "107",
    targetId: "desi",
    category: "Engineering",
    imgUrl: masterofEngineering,
    courseTitle: "Master of Engineering",
    courseDesc:
      "The University of Windsor offers Automotive Engineering, which features a specialized focus on electric powertrain engineering and controls for electric vehicles.",
    courseLink: "/course-details",
    country: "Canada",
    study_level: "Master Degree",
    paragraph1: "The Master of Engineering (MEng) at the University of Windsor is a course-based graduate program designed to provide advanced technical and applied engineering knowledge. Within the automotive-focused pathway, students are exposed to modern transportation systems with strong emphasis on electric and hybrid vehicle technologies, sustainable mobility, and automotive innovation.",
    paragraph2: "The program is structured to prepare graduates for industry roles by combining engineering fundamentals with real-world applications. Students gain knowledge in advanced vehicle systems, energy-efficient transportation, and next-generation automotive technologies, which are directly aligned with the global shift toward electric mobility.",
    paragraph3: "A key feature of this program is its industry-oriented learning approach. Students work on applied engineering problems related to automotive design, electrification, and smart mobility systems, preparing them for careers in the rapidly evolving electric vehicle sector.",
    pointText: "Electric Vehicle topics are covered within automotive and electrical engineering electives, including:",
    programOverview: [
      "Hybrid and Electric Vehicle Powertrains",
      "Electric Vehicle System Design and Control",
      "Battery Technology and Energy Storage Systems",
      "Power Electronics for EV Applications",
      "Vehicle Dynamics and Control Systems",
      "Smart and Autonomous Mobility Systems",
      "Automotive Thermal Management",
      "Sustainable Transportation Systems",
      "Automotive Manufacturing and Design",
      "Energy Efficiency and Propulsion Systems"
    ],

    courseReqText: "The program offers optional co-op opportunities where students may gain practical industry experience in automotive and engineering companies. These placements may involve work in electric vehicle development, automotive testing, system design, and manufacturing processes.",

    courseRequirement: {
      projectCourses: {
        title: "",
        courses: [
          
        ]
      },

      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Hybrid and Electric Vehicle Powertrains",
          "Electric Vehicle System Design and Control",
          "Battery Technology and Energy Storage Systems",
          "Power Electronics for EV Applications",
          "Vehicle Dynamics and Control Systems",
          "Smart and Autonomous Mobility Systems",
          "Automotive Thermal Management",
          "Sustainable Transportation Systems",
          "Automotive Manufacturing and Design",
          "Energy Efficiency and Propulsion Systems"
        ]
      },

      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Electric vehicle system design and analysis",
          "Battery and energy storage optimization",
          "Power electronics and electric drivetrains",
          "Automotive control systems engineering",
          "Vehicle performance evaluation",
          "Sustainable transportation solutions",
          "Problem-solving in automotive engineering",
          "Technical and systems-level thinking",
          "Engineering project management",
          "Industry-ready analytical and design skills"
        ]
      }
    },

    admissionRequirements: {
      description: "Admission requirements for the Master of Engineering in Automotive Engineering include an engineering background and supporting application documents.",

      admissionInfo: [
        "A 4-year Bachelor's degree in Mechanical Engineering (preferred for automotive focus)",
        "Electrical / Electronics Engineering",
        "Mechatronics or related engineering fields",
        "Minimum academic average: approximately 70–72% (or equivalent B grade)",
        "Statement of Purpose (SOP)",
        "CV / Resume",
        "Academic transcripts",
        "English proficiency: IELTS 6.5–7.0 depending on faculty requirements",
        "TOEFL iBT: approximately 83–100 range"
      ]
    },
    internShipParagraph1: "The program offers optional co-op opportunities where students may gain practical industry experience in automotive and engineering companies. These placements may involve work in electric vehicle development, automotive testing, system design, and manufacturing processes.",
    internShipParagraph2: "Even without co-op, students gain applied experience through project-based coursework and industry-relevant engineering assignments focused on real automotive challenges.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "Fall (September)",
      deadline: "N/A",
      duration: "12-16 months",
      fees: "CAD 30,000 - 40,000 (Approx)",
      applicationFee: "CAD 125 (Approx.)",
      language: "English",
      courseDelivery: "On-campus, full-time",
      courseRoute: "Course-based"
    }
  },
  {
    id: "108",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineering,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering – Electric Vehicle",
    courseDesc:
      "Master of Engineering (AUTO) program focused on hybrid and electric vehicle technologies",
    course_no: "8-Front",
    university: "University of Windsor"
  },
  {
    id: "109",
    targetId: "",
    imgUrl: MasterofManagement,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Management",
    courseTitle: "Master of Management",
    courseDesc:
      "The Master of Management is a unique, 16-month program that offers you the benefits of a world- class business education with the personal touch of a small",
    course_no: "9-Front",
    university: "University of Windsor",
    paragraph1:
      "The Master of Management (MM) at the University of Windsor is a professional graduate program designed to provide students with a strong foundation in business, leadership, and management. It is a 16-month program (with an optional 12-month accelerated track) that combines core business knowledge with specialized learning in areas such as data analytics, human resources, finance, and supply chain management.",

    paragraph2:
      "The program focuses on developing practical business skills and preparing students for careers in both private and public sectors. Students gain knowledge in key business areas such as accounting, marketing, finance, and strategy while also building leadership and decision-making abilities. The curriculum is designed to align with real-world business environments and global market needs.",

    paragraph3:
      "A key strength of the program is its flexibility and specialization options. Students can choose from streams like Business Data Analytics, Human Resource Management, International Accounting & Finance, and Logistics & Supply Chain Management. The program also offers a paid co-op option, allowing students to gain hands-on industry experience and build professional networks.",

    pointText:
      "Students study core business courses along with specialization-specific subjects:",

    programOverview: [
      "Accounting Concepts & Techniques",
      "Business Communication",
      "Finance in a Global Perspective",
      "Marketing",
      "Quantitative Studies",
      "Managing for Organizational Effectiveness",
      "Business Strategy (Capstone)",
      "Data Analytics & Predictive Modeling",
      "Human Resource Management & Employment Law",
      "International Financial Reporting & Auditing",
      "Supply Chain & Logistics Management",
      "Procurement & Transportation Systems"
    ],

    courseReqText:
      "The program offers an optional paid co-op opportunity where students gain real-world work experience in a professional setting. During the co-op term, students work in roles related to their specialization and apply classroom knowledge in practical environments.",

    courseRequirement: {
      projectCourses: {
        title: "",
        courses: [
          
        ]
      },

      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Accounting Concepts & Techniques",
          "Business Communication",
          "Finance in a Global Perspective",
          "Marketing",
          "Quantitative Studies",
          "Managing for Organizational Effectiveness",
          "Business Strategy (Capstone)",
          "Data Analytics & Predictive Modeling",
          "Human Resource Management & Employment Law",
          "International Financial Reporting & Auditing",
          "Supply Chain & Logistics Management",
          "Procurement & Transportation Systems"
        ]
      },

      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Leadership & management skills",
          "Business decision-making & strategy",
          "Financial analysis & accounting knowledge",
          "Data analytics & quantitative skills",
          "Communication & presentation skills",
          "Problem-solving in business environments",
          "Teamwork & organizational behavior understanding",
          "Marketing and global business awareness",
          "Project management skills",
          "Analytical thinking for real-world business challenges"
        ]
      }
    },

    admissionRequirements: {
      description:
        "Admission requirements for the Master of Management include academic qualifications and supporting application documents.",

      admissionInfo: [
        "A 4-year Bachelor’s degree (or equivalent)",
        "Minimum 70% average in undergraduate studies",
        "Statement of Intent (1–2 pages) explaining goals and motivation",
        "Updated CV / Resume",
        "Academic transcripts",
        "English language proficiency: IELTS 7.0 overall",
        "TOEFL iBT: 100",
        "Duolingo: 120"
      ]
    },
    internShipParagraph1: "The program offers an optional paid co-op opportunity where students gain real-world work experience in a professional setting. During the co-op term (minimum 420 hours), students work in roles related to their specialization and apply classroom knowledge in practical environments. This experience helps in building professional networks, enhancing resumes, and improving employability after graduation.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "Fall / Winter (varies by stream)",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 40,000 – 50,000 Total",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus, Full-Time",
      courseRoute: "Course-based with specialization + optional co-op"
    }
  },
  {
    id: "110",
    targetId: "health",
    category: "Health Science",
    imgUrl: MasterofMedicalBiotechnology,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Health Science",
    courseTitle: "Master of Medical Biotechnology",
    courseDesc:
      "The Master of Medical Biotechnology is a professional program that provides students with both a solid foundation of the theoretical concepts and practical",
    course_no: "10-Front",
    university: "University of Windsor",
    internShipParagraph1: "The program strongly emphasizes experiential and lab-based learning rather than traditional internships. Students gain hands-on experience through advanced laboratory work, research-based assignments, and industry-related projects. In addition, seminars, networking events, and workshops provide exposure to professionals in the biotech and pharmaceutical industries, helping students build connections and practical understanding of the field.",
    paragraph1:
      "The Master of Medical Biotechnology (MMB) at the University of Windsor is a professional graduate program designed to provide students with both strong theoretical knowledge and hands-on laboratory experience in the biotechnology and pharmaceutical fields. The program focuses on real-world applications of biotechnology, including diagnostics, drug development, and medical research.",

    paragraph2:
      "Students are trained in modern laboratory techniques along with an understanding of disease mechanisms and therapeutic development. In addition to scientific knowledge, the program also includes training in business concepts such as product commercialization and biotechnology entrepreneurship, making it unique compared to traditional science degrees.",

    paragraph3:
      "Overall, the program is career-focused and prepares graduates for roles in biotechnology companies, pharmaceutical industries, and research environments. It is also suitable for professionals already working in related fields who want to advance their careers.",

    pointText:
      "Students complete multidisciplinary courses covering biotechnology, pharmaceutical sciences, laboratory techniques, and business concepts including:",

    programOverview: [
      "Protein Structure & Function",
      "Clinical Biochemistry",
      "Human Physiology & Disease Mechanisms",
      "Drugs: From Discovery to Market",
      "Biotechnology Laboratory Techniques",
      "Biochemistry of Lipids & Membranes",
      "Biotechnology Entrepreneurship",
      "Strategic Management of Biotech Innovations",
      "Marketing / Business-related courses",
      "Leadership or International Business electives"
    ],

    courseReqText:
      "The program strongly emphasizes experiential and lab-based learning rather than traditional internships. Students gain hands-on experience through advanced laboratory work, research-based assignments, and industry-related projects.",

    courseRequirement: {
      projectCourses: {
        title: "",
        courses: [
         
        ]
      },

      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Protein Structure & Function",
          "Clinical Biochemistry",
          "Human Physiology & Disease Mechanisms",
          "Drugs: From Discovery to Market",
          "Biotechnology Laboratory Techniques",
          "Biochemistry of Lipids & Membranes",
          "Biotechnology Entrepreneurship",
          "Strategic Management of Biotech Innovations",
          "Marketing / Business-related courses",
          "Leadership or International Business electives"
        ]
      },

      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Advanced laboratory & experimental techniques",
          "Understanding of disease mechanisms & therapeutics",
          "Biotechnology product development skills",
          "Data analysis in biological sciences",
          "Scientific research & problem-solving",
          "Business planning & commercialization skills",
          "Communication & presentation in scientific context",
          "Teamwork in lab and research environments",
          "Analytical thinking in medical biotechnology",
          "Industry-relevant biotech and pharma skills"
        ]
      }
    },

    admissionRequirements: {
      description:
        "Admission requirements for the Master of Medical Biotechnology include a science-related academic background and supporting application documents.",

      admissionInfo: [
        "A 4-year Bachelor’s degree (BSc or Honours) in Biochemistry, Biology, Chemistry, or related field",
        "Related fields may include Pharmacy or Medicine",
        "Minimum 70% average (CGPA)",
        "Statement of Interest / Objectives",
        "CV / Resume",
        "Two Letters of Recommendation",
        "English language proficiency: IELTS 6.5 overall",
        "TOEFL iBT: 83",
        "Duolingo: 120",
        "Preference given to applicants with relevant experience"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "September & January",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 23,000 – 28,000 Per Year",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus, full-time",
      courseRoute: "Course-based"
    }

  },
  {
    id: "111",
    targetId: "",
    imgUrl: MasterofSportsManagement,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Sports Management",
    courseTitle: "Master of Sports Management And Leadership",
    courseDesc:
      "Prepares students to be effective managers and leaders in sport",
    course_no: "11-Front",
    university: "University of Windsor",
    paragraph1:
      "The Master of Sport Management & Leadership (MSML) at the University of Windsor is a globally recognized graduate program designed to prepare students for leadership roles in the sport industry. The program focuses on developing management, leadership, and strategic skills required to handle modern challenges in sports organizations. It also explores the social, cultural, and economic impact of sport in today’s world.",

    paragraph2:
      "The program offers two main pathways: a thesis-based option for students interested in research and an internship-based option for those who want practical industry experience. Students learn how to manage sport organizations, analyze policies, and create innovative solutions for issues in the sports sector.",

    paragraph3:
      "This program is highly career-focused and internationally ranked, with strong industry connections and high employment outcomes. Graduates work in areas such as sport marketing, event management, sponsorship, governance, and professional sports organizations.",

    pointText:
      "Students study a combination of management, research, and sport-specific subjects, including:",

    programOverview: [
      "Research Methods in Sport Management",
      "Social Issues in Sport Management",
      "Sport Marketing & Sponsorship",
      "Organizational Behaviour in Sport",
      "Sport Policy & Governance",
      "Leadership in Sport Organizations",
      "Sport Event Management",
      "Cultural & Social Aspects of Sport",
      "Elective courses in sport-related fields",
      "Internship course or Thesis research project"
    ],

    courseReqText:
      "The program offers a dedicated internship stream that includes approximately 360 hours of practical work experience in the sport and recreation sector. Students gain real-world exposure through placements with professional sports organizations and event management bodies.",

    courseRequirement: {
      projectCourses: {
        title: "",
        courses: [
         
        ]
      },

      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Research Methods in Sport Management",
          "Social Issues in Sport Management",
          "Sport Marketing & Sponsorship",
          "Organizational Behaviour in Sport",
          "Sport Policy & Governance",
          "Leadership in Sport Organizations",
          "Sport Event Management",
          "Cultural & Social Aspects of Sport",
          "Elective courses in sport-related fields",
          "Internship course or Thesis research project"
        ]
      },

      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Sport management & leadership skills",
          "Event planning and execution",
          "Marketing & sponsorship strategies in sports",
          "Policy analysis and governance in sport organizations",
          "Communication & stakeholder management",
          "Critical thinking about social issues in sport",
          "Team leadership and organizational skills",
          "Strategic decision-making",
          "Research and analytical skills",
          "Networking and professional relationship building"
        ]
      }
    },

    admissionRequirements: {
      description:
        "Admission requirements for the Master of Sport Management & Leadership include academic qualifications and supporting application documents.",

      admissionInfo: [
        "A 4-year Bachelor’s degree in Sport Management, Kinesiology / Human Kinetics, Business, or related field",
        "Minimum 70% average in the last two years of study",
        "Statement of Interest",
        "Two academic reference letters",
        "For thesis option, a supervisor may be required",
        "English language proficiency: IELTS 7.0",
        "TOEFL iBT: 100",
        "Duolingo: 130"
      ]
    },
    internShipParagraph1: "The program offers a dedicated internship stream that includes approximately 360 hours of practical work experience in the sport and recreation sector. Students get the opportunity to work with well-known organizations such as sports leagues, event organizers, and governing bodies. This hands-on experience allows students to apply classroom knowledge in real-world settings, build industry connections, and significantly improve their employability after graduation.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "N/A",
      duration: "16–20 months",
      fees: "CAD 20,000 – 30,000",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus, full-time",
      courseRoute: "Internship-based (coursework + 360-hour internship)"
    }
  },
  {
    id: "112",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineeringManagement,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering Management",
    courseDesc:
      "The MEM program prepares engineers for management roles. Graduates are ready to occupy leadership roles in multinational engineering and technical enterprises.",
    course_no: "12-Front",
    university: "University of Windsor",
    paragraph1:
      "The Master of Engineering Management (MEM) at the University of Windsor is a professional graduate program designed to combine engineering knowledge with business and management skills. It prepares engineers to move into leadership and managerial roles in technical industries such as manufacturing, technology, and operations.",

    paragraph2:
      "The program is jointly offered by the Faculty of Engineering and the business school, focusing on real-world applications such as product development, operations strategy, and innovation management. Students learn how to manage engineering projects, analyze business decisions, and lead teams in complex technical environments.",

    paragraph3:
      "This is a course-based program with a strong practical focus rather than research. A major component is the capstone project, where students apply their knowledge to real industry problems such as feasibility studies, business plans, or engineering management reports.",

    pointText:
      "Students complete core management and engineering-focused courses including:",

    programOverview: [
      "Product Innovation & Design Management",
      "Financial & Managerial Accounting for Engineers",
      "Engineering Project Management",
      "Applied Finance for Engineering Managers",
      "Data Analytics & Decision-Making",
      "Strategic Management",
      "Supply Chain Management",
      "Operations Management",
      "Entrepreneurship & Innovation",
      "Engineering Management Capstone Project"
    ],

    courseReqText:
      "The MEM program does not include a traditional internship, but students gain strong practical experience through industry-focused capstone projects and real-world engineering management assignments.",

    courseRequirement: {
      projectCourses: {
        title: "Practical Experience / Capstone Project",
        courses: [
          "Industry-focused capstone project across 2 terms",
          "Engineering feasibility studies and management reports",
          "Business plan development for technical industries",
          "Real-world engineering problem-solving",
          "Collaboration opportunities with industry partners",
          "Professional networking and practical exposure"
        ]
      },

      coreCourses: {
        title: "Courses Covered",
        courses: [
          "Product Innovation & Design Management",
          "Financial & Managerial Accounting for Engineers",
          "Engineering Project Management",
          "Applied Finance for Engineering Managers",
          "Data Analytics & Decision-Making",
          "Strategic Management",
          "Supply Chain Management",
          "Operations Management",
          "Entrepreneurship & Innovation",
          "Engineering Management Capstone Project"
        ]
      },

      electiveCourses: {
        title: "Skills You Will Learn",
        courses: [
          "Engineering project management",
          "Business & financial decision-making",
          "Data analytics for engineering problems",
          "Leadership & team management",
          "Product development & innovation strategies",
          "Supply chain & operations management",
          "Strategic thinking in technical organizations",
          "Problem-solving in real engineering environments",
          "Communication & management skills",
          "Technology commercialization & business planning"
        ]
      }
    },

    admissionRequirements: {
      description:
        "Admission requirements for the Master of Engineering Management include an engineering background and supporting academic documents.",

      admissionInfo: [
        "A 4-year Bachelor’s degree in Engineering or related field",
        "Minimum B grade (around 70%+) in the last two years of study",
        "Preference for candidates with 2+ years of relevant work experience",
        "Statement of Interest (around 500 words)",
        "CV / Resume",
        "Two Letters of Recommendation",
        "Academic transcripts",
        "English language proficiency: IELTS 7.0",
        "TOEFL iBT: 100",
        "Duolingo: 120"
      ]
    },
    internShipParagraph1: "The MEM program does not include a traditional internship, but it has a strong capstone project component that acts as real-world experience. Students work on industry-related problems such as engineering feasibility studies, management reports, or business plans. In some cases, these projects can be completed in collaboration with industry partners, providing practical exposure and networking opportunities.",
    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "N/A",
      duration: "16 months",
      fees: "CAD 22,000 – 28,000 per year",
      applicationFee: "CAD 125",
      language: "English",
      courseDelivery: "On-campus (full-time)",
      courseRoute: "Course-based"
    }
  },
  {
    id: "113",
    targetId: "deve",
    category: "Business",
    imgUrl: MasterofBusinessAdministration,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Business",
    courseTitle: "Master of Business Administration",
    courseDesc:
      "UNB's MBA is a flexible, high-quality program designed for working professionals",
    course_no: "13-Front",
    university: "UNB"
  },
  {
    id: "114",
    targetId: "",
    imgUrl: MasterofQuantitativeInvestmentManagement,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Management",
    courseTitle: "Master of Quantitative Investment Management",
    courseDesc:
      "A one-of-a-kind graduate program focused on quantitative investment skills",
    course_no: "14-Front",
    university: "UNB"
  },
  {
    id: "115",
    targetId: "desi",
    category: "Engineering",
    imgUrl: TechnologyManagementandEntrepreneurship,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Technology Management and Entrepreneurship",
    courseDesc:
      "MTME program combining technological thinking with practical business skills",
    course_no: "15-Front",
    university: "UNB"
  },
  {
    id: "116",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineeringLeadershipinDesignInnovation,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering Leadership in Design Innovation",
    courseDesc:
      "Combines engineering education with leadership, management, and innovation training",
    course_no: "16-Front",
    university: "UNB"
  },
  {
    id: "117",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineering2,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering",
    courseDesc:
      "The MEng degree for those who wish to study geomatics engineering",
    course_no: "17-Front",
    university: "NB"
  },
  {
    id: "118",
    targetId: "",
    imgUrl: MasterofEnvironmentalManagement,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Environmental Science",
    courseTitle: "Master of Environmental Management",
    courseDesc:
      "Graduate program integrating environmental science, policy and management",
    course_no: "18-Front",
    university: "NB"
  },
  {
    id: "119",
    targetId: "",
    imgUrl: MasterofComputerScience,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Computer Science",
    courseTitle: "Master of Computer Science (MCSC)",
    courseDesc:
      "This graduate program focused on advanced computer science knowledge and skills, suitable for those not interested in research",
    course_no: "19-Front",
    university: "NB"
  },
  {
    id: "120",
    targetId: "",
    imgUrl: MasterofAppliedCybersecurity,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Computer Science",
    courseTitle: "Master of Applied Cybersecurity (MACSec)",
    courseDesc:
      "This program preparing students for cybersecurity careers through training in network security, digital forensics, cryptanalysis, and threat protection",
    course_no: "20-Front",
    university: "NB"
  },
  {
    id: "121",
    targetId: "",
    imgUrl: MasterofEducation,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Education",
    courseTitle: "Master of Education",
    courseDesc:
      "Master of Education (MEd) program with online and in-person options, designed to advance careers in education",
    course_no: "21-Front",
    university: "NB"
  },
  {
    id: "122",
    targetId: "deve",
    category: "Business",
    imgUrl: MasterofBusinessAdministration2,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Business",
    courseTitle: "Pre -MBA",
    courseDesc:
      "This Pre-MBA program at its Saint John campus, which is an intensive, designed primarily for international students to bridge the gap…",
    course_no: "22-Front",
    university: "NB"
  },
  {
    id: "123",
    targetId: "",
    imgUrl: MasterofAppliedPsychologyResearchandEvaluation,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Applied Science",
    courseTitle: "Master of Applied Psychology Research and Evaluation",
    courseDesc:
      "This program is designed for students interested in applying psychological principles to research and evaluation in various fields…",
    course_no: "23-Front",
    university: "NB"
  },

  /* ============================================================
     DALHOUSIE UNIVERSITY
     ============================================================ */

  {
    id: "124",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: MasterofAppliedComputerScience,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Information Technology",
    courseTitle: "Master of Applied Computer Science",
    courseDesc:
      "The Master of Applied Computer Science (MACS) program is a 16-month graduate degree that prepares you for a dynamic career in the software industry.",
    courseLink: "/course-details",
    course_no: "24-Front",
    university: "Dalhousie University",

    paragraph1:
      "The Master of Applied Computer Science (MACS) program is a 16-month graduate degree that prepares you for a dynamic career in the software industry by developing strong technical skills with core courses in systems, communications, and data management.",

    paragraph2:
      "You'll develop the technical skills needed for rapid advancement in the software industry through in-demand required courses in mobile computing, data management, warehousing and analytics, and communications. This program is a strong fit whether you're an IT professional working in Canada, coming directly from an undergraduate degree, or an internationally trained professional.",

    paragraph3:
      "A Master of Applied Computer Science degree adds value to your career and can open new opportunities in the IT industry and beyond. With the skills you learn in this course-based master's program, you'll be able to connect with and contribute to information technology advancements across industries.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Software Engineer",
      "Solutions Architect",
      "Software Developer",
      "Chief Technology Officer"
    ],

    courseReqText:
      "This is a course-based professional master's program with options that let you apply your learning in real-world contexts, including an internship option and an entrepreneurship option.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: [
          "Internship: Gain technical experience in the context of an industry work placement",
          "Entrepreneurship: Learn the technical and business knowledge needed to create your own business"
        ]
      },

      coreCourses: {
        title: "Courses Include",
        courses: [
          "Privacy & IT",
          "Communicating Computer Science Ideas",
          "Technology Innovation",
          "Software Comprehension",
          "Advanced Topics in Software Development",
          "Data Management, Warehousing, and Analytics"
        ]
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a minimum second-class engineering degree (or equivalent) from a university of recognized standing.",

      admissionInfo: [
        "Intake: September (each year)",
        "Relevant Bachelor Degree + Transcript (CGPA of 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) Letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT, In-Person or Special At-Home Edition - Score 92",
        "2 Reference / Recommendation Letters from a Professor or Assistant Professor"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "N/A",
      duration: "16 Months or Longer",
      fees: "$115",
      applicationFee: "$90",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course Based"
    }
  },

  {
    id: "125",
    targetId: "seo",
    category: "Information Technology",
    imgUrl: MasterofDigitalInnovation,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Information Technology",
    courseTitle: "Master of Digital Innovation",
    courseDesc:
      "Learn technical, business, and leadership skills to manage change and drive value in the digital economy.",
    courseLink: "/course-details",
    course_no: "25-Front",
    university: "Dalhousie University",

    paragraph1:
      "Gain the knowledge and experience needed to boost your digital management career within any industry or sector. In the Master of Digital Innovation (MDI), you'll not only learn from experts from the Faculties of Computer Science, Management, and Law but also have the opportunity to customize your experience through certificate options that will provide you with a distinct set of skills and knowledge to meet your career objectives.",

    paragraph2:
      "Graduates of the Master of Digital Innovation program at Dalhousie University work in diverse fields such as technology, health care, and consulting.",

    paragraph3:
      "The Faculty of Computer Science reports strong graduate outcomes, with many graduates remaining in Canada after graduation and a high proportion securing employment in technology related fields.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Digital Strategy Consultant",
      "Technology Product Manager",
      "Technology Director",
      "Senior Health Information Analyst",
      "ERP Consultant"
    ],

    courseReqText:
      "The Master of Digital Innovation offers professional, thesis, and internship routes so you can shape the degree around your career goals.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: [
          "Professional: This course-based master's program will enable you to acquire specialized knowledge, enhance critical skills, and advance your career",
          "Thesis: Perform rigorous research under the supervision of a researcher in your chosen field",
          "Internship: Learn from leading experts and experience first-hand how digital innovation is transforming organizations"
        ]
      },

      coreCourses: {
        title: "Courses / Areas of Study Include",
        courses: [
          "Foundations in Web Technologies",
          "Foundations in Business",
          "Law, Policy, and Ethics in Emerging Technologies",
          "Digital Transformation",
          "Business Process Improvement, Automation, and Change Management",
          "Business Analytics and Data Visualization"
        ]
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants may come from an undergraduate or graduate degree across diverse disciplines (computer science, business, law, health, etc.).",

      admissionInfo: [
        "Intake: September (each year)",
        "Relevant Bachelor's degree + transcript (minimum GPA 3.0)",
        "Work experience (if applicable)",
        "Updated resume",
        "English as Medium of Instruction (MOI) letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT (In-Person or Special At-Home Edition) - Score 92",
        "2 reference/recommendation letters from a professor or assistant professor"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "N/A",
      duration: "16 Months or Longer",
      fees: "N/A",
      applicationFee: "$115 CAD",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course-based / Internship"
    }
  },

  {
    id: "126",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineeringBiological,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering - Biological",
    courseDesc:
      "Biological Engineering applies natural science and engineering principles to the biological world.",
    courseLink: "/course-details",
    course_no: "26-Front",
    university: "Dalhousie University",

    paragraph1:
      "The Biological Engineering program has focused research in environmental engineering and biosystems engineering. Research projects that you can take part in therefore encompass both specific environmental concerns and the sustainable utilization of natural resources.",

    paragraph2:
      "The program has co-operative projects with faculty members in other universities both locally and internationally. Opportunities exist to participate in these research projects, providing wider experience and in which a specific component leads to a Master's degree.",

    paragraph3:
      "Process Engineering and Applied Science at Dalhousie prepares students for various careers in the process and chemical industries. Students may also work in the growing fields of biotechnology, food processing, composite material, corrosion and protective coatings, and microelectronic component manufacturing.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Traditional areas of environmental control (plastics and polymers, pulp, and paper)",
      "Instrumentation and process control",
      "Petrochemicals, petroleum, and natural gas processing",
      "Energy conversion and use"
    ],

    courseReqText:
      "Standard Program Duration: 16 Months or Longer.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: [
          "Professional: This course-based master's program will enable you to acquire specialized knowledge, enhance critical skills, and advance your career",
          "Project: Complete a project that draws on your knowledge and experience in the field"
        ]
      },

      coreCourses: {
        title: "",
        courses: []
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a relevant degree from a university of recognized standing.",

      admissionInfo: [
        "Relevant Bachelor's Degree + Transcript (Minimum GPA 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT (In-Person or Special At-Home Edition) - Score 92",
        "2 reference/recommendation letters from a professor or assistant professor",
        "Intake: January, May, and September",
        "January Admission (Deadline August 30)",
        "May Admission (Deadline December 30)",
        "September Admission (Deadline April 1)"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "Jan, May, Sept",
      deadline: "Aug 30 / Dec 30 / Apr 1",
      duration: "16 Months or Longer",
      fees: "N/A",
      applicationFee: "$115 CAD",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course-based"
    }
  },

  {
    id: "127",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineeringChemical,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering - Chemical",
    courseDesc:
      "This program Chemical Engineering prepares students for a variety of careers in the chemical and process industries.",
    courseLink: "/course-details",
    course_no: "27-Front",
    university: "Dalhousie University",

    paragraph1:
      "Graduate studies in Chemical Engineering encompasses areas of environmental control, plastics and polymers, pulp and paper, instrumentation and process control, petrochemicals, petroleum and natural gas processing, and energy conversion and utilization, as well as the growing fields of biotechnology, food processing, composite materials, corrosion and protective coatings, and manufacture of microelectronic components.",

    paragraph2:
      "Opportunities to explore these areas are available within the department, in collaboration with other departments, and through several research centers on campus. The Dalhousie Chemical Engineering program houses faculty members with research interests in the areas of bioprocessing and drug delivery, dust explosion and risk management, pilot-scale design and system testing, multiphase process engineering, oil and gas processing and release mitigation, hybrid separation technology, and fermentation processing.",

    paragraph3:
      "The responsibilities assumed by Chemical Engineers include a wide range of activities such as research and development of novel products and processes, the design, development and operation of process plants, and management of technical operations and sales. A MASc in Chemical Engineering can provide significant flexibility in career pathways, depending on your interests.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Water treatment",
      "Environmental remediation",
      "Industrial processing",
      "Oil and gas engineering and transportation",
      "Government services and consultation",
      "Legal and patent processing",
      "Medical device manufacturing and systems management",
      "Academia and education"
    ],

    courseReqText: "Standard Program Option: 2 Years or Longer, Full Time.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: ["2 Years or Longer", "Full Time"]
      },

      coreCourses: {
        title: "",
        courses: []
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a relevant degree from a university of recognized standing.",

      admissionInfo: [
        "Relevant Bachelor's Degree + Transcript (Minimum GPA 3.0)",
        "Work Experience (If Applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT (In-Person or Special At-Home Edition) - Score 92",
        "Medium of Instruction Letter (MOI)",
        "2 reference/recommendation letters from a professor or assistant professor",
        "Intake: January and September",
        "January Admission (Deadline August 30)",
        "September Admission (Deadline April 1)"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "Jan, Sept",
      deadline: "Aug 30 / Apr 1",
      duration: "2 Years",
      fees: "N/A",
      applicationFee: "$115 CAD",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course-based"
    }
  },

  {
    id: "128",
    targetId: "desi",
    category: "Engineering",
    imgUrl: MasterofEngineeringChemical,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Engineering",
    courseTitle: "Master of Engineering – Chemical (MEng)",
    courseDesc:
      "Explore a wide range of topics within the field of Chemical Engineering in this course-based master's degree.",
    courseLink: "/course-details",
    course_no: "28-Front",
    university: "Dalhousie University",

    paragraph1:
      "Graduate studies in Chemical Engineering encompasses areas of environmental control, plastics and polymers, pulp and paper, instrumentation and process control, petrochemicals, petroleum and natural gas processing, and energy conversion and utilization, as well as the growing fields of biotechnology, food processing, composite materials, corrosion and protective coatings, and manufacture of microelectronic components.",

    paragraph2:
      "Opportunities to explore these areas are available within the department, in collaboration with other departments, and through several research centers on campus. The Dalhousie Chemical Engineering program houses faculty members with research interests in the areas of bioprocessing and drug delivery, dust explosion and risk management, pilot-scale design and system testing, multiphase process engineering, oil and gas processing and release mitigation, hybrid separation technology, and fermentation processing.",

    paragraph3:
      "The responsibilities assumed by Chemical Engineers include a wide range of activities such as research and development of novel products and processes, the design, development and operation of process plants, and management of technical operations and sales. A MEng in Chemical Engineering can provide significant flexibility in career pathways, depending on your interests.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Water treatment",
      "Environmental remediation",
      "Industrial processing",
      "Oil and gas engineering and transportation",
      "Government services and consultation",
      "Legal and patent processing",
      "Medical device manufacturing and systems management",
      "Academia and education"
    ],

    courseReqText:
      "A professionally oriented, course-based degree requiring the completion of a graduate seminar and a project.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: [
          "Course-based: A professionally oriented, course-based degree requiring the completion of a graduate seminar and a project",
          "Project: Complete a project that draws on your knowledge and experience in the field",
          "16 Months or Longer",
          "Full Time",
          "Coursework degree: 9 courses, professionally-oriented (course-based, no thesis)"
        ]
      },

      coreCourses: {
        title: "",
        courses: []
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants must have a relevant degree from a university of recognized standing.",

      admissionInfo: [
        "Relevant Bachelor's Degree + Transcript (Minimum GPA 3.0)",
        "Work Experience (if applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT (In-Person or Special At-Home Edition) - Score 92",
        "2 reference/recommendation letters from a professor or assistant professor",
        "Intake: January and September",
        "January Admission - Deadline August 30",
        "September Admission - Deadline April 1"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "Jan, Sept",
      deadline: "Aug 30 / Apr 1",
      duration: "2 Years",
      fees: "N/A",
      applicationFee: "$115 CAD",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course-based"
    }
  },

  {
    id: "129",
    targetId: "deve",
    category: "Business",
    imgUrl: MasterofPublicAdministration,
    country: "Canada",
    study_level: "Master Degree",
    faculty: "Management",
    courseTitle: "Master of Public Administration (MPA)",
    courseDesc:
      "Dalhousie's Master of Public Administration program empowers you to tackle the world's most intricate societal challenges and make a meaningful impact on a global scale.",
    courseLink: "/course-details",
    course_no: "29-Front",
    university: "Dalhousie University",

    paragraph1:
      "Dalhousie's Master of Public Administration program empowers you to tackle the world's most intricate societal challenges, equipping you to make a meaningful impact on a global scale.",

    paragraph2:
      "Through a curriculum designed to inspire social change and navigate complex public ecosystems, you'll gain the skills to collaborate across boundaries and drive transformation in public organizations. By offering a diverse range of perspectives in politics and policy, the program teaches you how to address complex global issues effectively.",

    paragraph3:
      "This is a direct-entry program, meaning all undergraduate degrees are acceptable, and no experience is necessary for admission. Students can directly enter the profession after graduating. The MPA helps you gain management skills that will allow you to excel in a variety of roles in the public, private, and not-for-profit sectors.",

    pointText: "Possible Careers Include:",

    programOverview: [
      "Management consultant",
      "Policy analyst",
      "Communications advisor",
      "Research and statistical officer",
      "Fundraising and development"
    ],

    courseReqText:
      "The Dalhousie MPA is a course-based program delivered in person, on campus. An optional four-month internship allows you to apply classroom learning in a real-world setting.",

    courseRequirement: {
      projectCourses: {
        title: "Program Options",
        courses: [
          "Standard Program Duration: 20 Months or Longer",
          "Enrollment Option: Full Time",
          "Optional four-month internship to apply classroom learning in a real-world setting",
          "Complete your degree faster: students with an undergraduate degree in public policy or public administration may be eligible for a fast-track, 1-year MPA program"
        ]
      },

      coreCourses: {
        title: "",
        courses: []
      },

      electiveCourses: {
        title: "",
        courses: []
      }
    },

    admissionRequirements: {
      description:
        "To be considered for admission, applicants may hold an undergraduate degree in any discipline — this is a direct-entry program.",

      admissionInfo: [
        "Relevant Bachelor's Degree + Transcript (Minimum GPA 3.0)",
        "Work Experience (if applicable)",
        "Updated Resume",
        "English as Medium of Instruction (MOI) letter",
        "IELTS 7.0 / PTE 65, nothing below 54",
        "TOEFL iBT (In-Person or Special At-Home Edition) - Score 92",
        "2 reference/recommendation letters from a professor or assistant professor",
        "Intake: September",
        "September Admission - Deadline January 31"
      ]
    },

    courseDetail: {
      stydyLevel: "Master",
      intake: "September",
      deadline: "January 31",
      duration: "20 Months or Longer",
      fees: "N/A",
      applicationFee: "$115 CAD",
      language: "English",
      courseDelivery: "In Person",
      courseRoute: "Course-based"
    }
  }



];
